import * as CSS from "./live-status.styles";

const LiveStatus = () => {
	return (
		<CSS.LiveStatus>
			<CSS.LiveIndicator>
				<CSS.IndicatorBorder />
				<CSS.IndicatorCenter />
			</CSS.LiveIndicator>
			<CSS.LiveText>LIVE</CSS.LiveText>
		</CSS.LiveStatus>
	);
};

export default LiveStatus;
